// extracted by mini-css-extract-plugin
export default {"button":"ContextMenuButton_button__AlXXT","text":"ContextMenuButton_text__PjB3w","image":"ContextMenuButton_image__ib3VR"};